import React from 'react';
import * as css from '../AIMessageGenerator.css';
import GeneratorChatMessage from '../generatorChatMessage/GeneratorChatMessage';
import GeneratorTypingIndicator from '../generatorTypingIndicator/GeneratorTypingIndicator';
import type {
    AIMessageGeneratorAssistantFooterProps,
    AIMessageGeneratorUserMessageProps,
    AssistantDraftPayload,
    ChatMessage,
    SubmitPromptOptions,
} from '../utils/types';

interface GeneratorChatListProps {
    messages: ChatMessage[];
    draftLoading: boolean;
    approveLabel?: string;
    approveLoading: boolean;
    onApprove?: (draft: AssistantDraftPayload) => void;
    onEditMessage?: (index: number, newText: string) => void;
    onSubmitPrompt: (options?: SubmitPromptOptions) => void;
    renderUserMessage?: (props: AIMessageGeneratorUserMessageProps) => React.ReactNode;
    renderAssistantFooter?: (props: AIMessageGeneratorAssistantFooterProps) => React.ReactNode;
}

function GeneratorChatList({
    messages,
    draftLoading,
    approveLabel,
    approveLoading,
    onApprove,
    onEditMessage,
    onSubmitPrompt,
    renderUserMessage,
    renderAssistantFooter,
}: GeneratorChatListProps) {
    return (
        <css.chatColumn>
            {messages.map((message, index) => (
                message.role === 'user' && renderUserMessage ? (
                    <React.Fragment key={message.id ?? index}>
                        {renderUserMessage({message, index, onEditMessage, draftLoading})}
                    </React.Fragment>
                ) : (
                    <GeneratorChatMessage
                        key={message.id ?? index}
                        message={message}
                        index={index}
                        messages={messages}
                        draftLoading={draftLoading}
                        approveLabel={approveLabel}
                        approveLoading={approveLoading}
                        onApprove={onApprove}
                        footer={message.role === 'assistant' && renderAssistantFooter
                            ? renderAssistantFooter({
                                message,
                                index,
                                isLast: index === messages.length - 1,
                                draftLoading,
                                onSubmitPrompt,
                            })
                            : undefined}
                    />
                )
            ))}
            {draftLoading && <GeneratorTypingIndicator />}
        </css.chatColumn>
    );
}

export default GeneratorChatList;
